import Controller from '@ember/controller'
import type CaseStudiesRoute from 'teacher-ui-client/subscription-type/quick-links/case-studies/route'

export default class CaseStudiesController extends Controller {
  declare model: ModelFor<CaseStudiesRoute>

  get caseStudies() {
    return this.getCaseStudiesViewModel(this.model.caseStudies)
  }

  private getCaseStudiesViewModel(caseStudiesContentfulData: ModelFor<CaseStudiesRoute>['caseStudies']) {
    return (
      caseStudiesContentfulData
        ?.filter((entry) => entry.fields.cover?.fields?.file?.url && entry.fields.file?.fields.file?.url)
        .map((entry) => {
          return {
            title: entry.fields.title,
            description: entry.fields.description,
            subscriptionType: entry.fields.subscriptionType,
            // @ts-expect-error - we're filtering out entries without a cover or file url so these will always be defined
            coverUrl: entry.fields.cover.fields.file.url,
            // @ts-expect-error - we're filtering out entries without a cover or file url so these will always be defined
            fileUrl: entry.fields.file.fields.file.url,
          }
        }) || []
    )
  }
}
